export default "__VITE_ASSET__DToOMr$s__"